import {
  AlmostCompleteIcon,
  AnalyticsIcon,
  AppleIcon,
  ArchiveIcon,
  AttachIcon,
  AuctionIcon,
  BlockIcon,
  BuyerProtectionIcon,
  BuyNowClockIcon,
  CalendarDateRangeIcon,
  CalendarSingleDateIcon,
  CatawikiIcon,
  CopyIcon,
  CreateDocumentIcon,
  CreditCardCheckIcon,
  CreditCardIcon,
  CustomsIcon,
  DocumentIcon,
  DownloadIcon,
  EditIcon,
  ErrorIcon,
  EuroIcon,
  ExternalLinkIcon,
  EyeCrossedIcon,
  EyeIcon,
  FacebookIcon,
  FiltersIcon,
  GoogleIcon,
  HandsetIcon,
  HeartIcon,
  HeartOutlinedIcon,
  HelpIcon,
  HistoryIcon,
  HomeIcon,
  ImageIcon,
  InAuctionIcon,
  InfoIcon,
  InstagramIcon,
  LightBulbIcon,
  LiveHelpIcon,
  MailIcon,
  MessagingIcon,
  MoneyIcon,
  NegativeFeedbackIcon,
  NeutralFeedbackIcon,
  NotificationErrorIcon,
  PackageIcon,
  PauseIcon,
  PaymentIcon,
  PhoneIcon,
  PhotoCameraIcon,
  PickUpIcon,
  PlayIcon,
  PlusIcon,
  PositiveFeedbackIcon,
  ProfileIcon,
  QualityCheckedIcon,
  RefreshIcon,
  ReloadIcon,
  ReofferIcon,
  RotateLeftIcon,
  RotateRightIcon,
  SearchIcon,
  SecurePaymentIcon,
  SendIcon,
  SoldIcon,
  SpinnerIcon,
  SuccessEmptyIcon,
  SuccessFillIcon,
  SuccessIcon,
  TagIcon,
  TimeIcon,
  TrashIcon,
  TrendingIcon,
  TruckIcon,
  UnarchiveIcon,
  VerifiedSellerIcon,
  VoucherIcon,
  WarningIcon,
} from '@catawiki/cata-style';

export const IconMap = {
  AlmostComplete: AlmostCompleteIcon,
  Analytics: AnalyticsIcon,
  Apple: AppleIcon,
  Archive: ArchiveIcon,
  Attach: AttachIcon,
  Auction: AuctionIcon,
  Block: BlockIcon,
  BuyNowClock: BuyNowClockIcon,
  BuyerProtection: BuyerProtectionIcon,
  CalendarDateRange: CalendarDateRangeIcon,
  CalendarSingleDate: CalendarSingleDateIcon,
  Catawiki: CatawikiIcon,
  Copy: CopyIcon,
  CreateDocument: CreateDocumentIcon,
  CreditCardCheck: CreditCardCheckIcon,
  CreditCard: CreditCardIcon,
  Customs: CustomsIcon,
  Document: DocumentIcon,
  Download: DownloadIcon,
  Edit: EditIcon,
  Error: ErrorIcon,
  Euro: EuroIcon,
  ExternalLink: ExternalLinkIcon,
  EyeCrossed: EyeCrossedIcon,
  Eye: EyeIcon,
  Facebook: FacebookIcon,
  Filters: FiltersIcon,
  Google: GoogleIcon,
  Handset: HandsetIcon,
  Heart: HeartIcon,
  HeartOutlined: HeartOutlinedIcon,
  Help: HelpIcon,
  History: HistoryIcon,
  Home: HomeIcon,
  Image: ImageIcon,
  InAuction: InAuctionIcon,
  Info: InfoIcon,
  Instagram: InstagramIcon,
  LightBulb: LightBulbIcon,
  LiveHelp: LiveHelpIcon,
  Mail: MailIcon,
  Messaging: MessagingIcon,
  Money: MoneyIcon,
  NegativeFeedback: NegativeFeedbackIcon,
  NeutralFeedback: NeutralFeedbackIcon,
  NotificationError: NotificationErrorIcon,
  Package: PackageIcon,
  Pause: PauseIcon,
  Payment: PaymentIcon,
  Phone: PhoneIcon,
  PhotoCamera: PhotoCameraIcon,
  PickUp: PickUpIcon,
  Play: PlayIcon,
  Plus: PlusIcon,
  PositiveFeedback: PositiveFeedbackIcon,
  Profile: ProfileIcon,
  QualityCheck: QualityCheckedIcon,
  Refresh: RefreshIcon,
  Reload: ReloadIcon,
  Reoffer: ReofferIcon,
  RotateLeft: RotateLeftIcon,
  RotateRight: RotateRightIcon,
  Search: SearchIcon,
  SecurePayment: SecurePaymentIcon,
  Send: SendIcon,
  Sold: SoldIcon,
  Spinner: SpinnerIcon,
  SuccessEmpty: SuccessEmptyIcon,
  SuccessFill: SuccessFillIcon,
  Success: SuccessIcon,
  Tag: TagIcon,
  Time: TimeIcon,
  Trash: TrashIcon,
  Trending: TrendingIcon,
  Truck: TruckIcon,
  Unarchive: UnarchiveIcon,
  VerifiedSeller: VerifiedSellerIcon,
  Voucher: VoucherIcon,
  Warning: WarningIcon,
};

export type IconName = keyof typeof IconMap;
export const IconNames = Object.keys(IconMap) as IconName[];
